<template>
    <div class="section">
        <h1 class="title has-text-centered">Profile information</h1>
        <app-loader :loading="getLoaderStatus"
                    :color="options.color"
                    :size="options.size"
                    class="fixed-center">
        </app-loader>
        <div class="columns" v-if="!getLoaderStatus">
            <div class="column">
                <div class="box">
                    <contacts v-if="!getLoaderStatus"></contacts>
                </div>
            </div>
            <div class="column">
                <consignees v-if="!getLoaderStatus"></consignees>
                <invoice-details v-if="!getLoaderStatus"></invoice-details>
            </div>
        </div>
    </div>
</template>

<script>
    import appLoader from 'vue-spinner/src/ClipLoader'
    import Consignees from './Consignees.vue'
    import InvoiceDetails from './InvoiceDetails.vue'
    import Contacts from './Contacts.vue'
    export default {
        components: {
            appLoader,
            Consignees,
            InvoiceDetails,
            Contacts
        },
        data () {
            return {
                options: this.$store.getters.getOptions
            }
        },
        created () {
            this.$store.dispatch('fetchCurrentLoginUser')
        },
        computed: {
            getLoaderStatus() {
                return this.$store.getters.getLoaderStatus
            }
        }
    }
</script>

<style scoped>
    .title {
        padding-top: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Profile/Profile.vue